<template>
    <div>
        <table class="table table-bordered table-sm">
            <!-- <thead class="thead-light">
                <tr class="text-center">
                    <th colspan="2">{{ "알람 개요" }}</th>
                </tr>
            </thead> -->
            <tbody>
                <tr style="background-color: #e9ecef">
                    <th class="text-center" colspan="2">{{ "알람 개요" }}</th>
                </tr>
                <tr v-for="(item, index) in overviewTable" :key="'overview-' + index">
                    <th class="text-center align-content-center" style="width: 30%">
                        {{ item.label }}
                    </th>

                    <td :class="{ alarmId: item.label === '알람 ID' }">
                        <span>
                            {{ item.value }}
                        </span>
                        <b-button
                            v-if="item.label === '알람 ID' && routeMgmt"
                            class="linkAlarmMgmt"
                            @click="handleTotalLogModal(true)"
                            ><i class="fa fa-external-link-alt"></i>
                        </b-button>
                    </td>
                </tr>
                <tr style="background-color: #e9ecef">
                    <th class="text-center" colspan="2">{{ "이벤트 개요" }}</th>
                </tr>
                <tr v-for="(item, index) in eventTableData" :key="'event-' + index">
                    <th class="text-center align-content-center" style="width: 30%">{{ item.label }}</th>
                    <td>{{ item.value }}</td>
                </tr>
                <tr style="background-color: #e9ecef">
                    <th class="text-center" colspan="2">{{ "데이터 분포" }}</th>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="boxPlot-chart-container">
                            <BoxPlotChart :boxPlotData="boxPlotData" :pointInfo="pointInfo" />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import BoxPlotChart from "../chart/BoxPlotChart";
import backEndApi from "@src/api/backEndApi";

export default {
    props: {
        alarmDetail: { type: Object, default: () => {} },
        eventInfo: { type: Object, default: () => {} },
        routeMgmt: { type: Boolean, default: false },
        pointInfo: { type: Object, default: () => {} },
        totalLog: { type: Array, default: () => [] },
        events: { type: Object, default: () => {} },
    },
    components: {
        BoxPlotChart,
    },
    data() {
        return {
            missingEventOverview: {},
        };
    },
    watch: {
        eventInfo: {
            async handler(newVal) {
                if (newVal && this.isMissingEvent()) {
                    await this.getMissingEventOverview(newVal.eventIdx);
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["commonCodes"]),
        alarm() {
            return this.alarmDetail ? this.alarmDetail.alarm : null;
        },
        event() {
            let data;
            if (this.eventInfo.alarmType == "AbnormalData" && this.events?.abnormalEvents) {
                data = this.events.abnormalEvents.find((item) => item.eventIdx == this.eventInfo.eventIdx);
            } else if (this.eventInfo.alarmType == "MissingData") {
                data = this.eventInfo;
            } else data = null;
            return data;
        },
        overviewTable() {
            if (!this.alarm || !this.event) return [];
            return [
                { label: "알람 ID", value: this.alarmLogIdx ? this.alarmLogIdx : "-" },
                { label: "알람 유형", value: this.alarm.alarmType ? this.convertAlarmType(this.alarm.alarmType) : "-" },
                { label: "심각도", value: this.alarm.severity ? this.convertAlarmSeverity(this.alarm.severity) : "-" },
                { label: "상태", value: this.alarm.status ? this.convertAlarmStatus(this.alarm.status) : "-" },
                {
                    label: "발생 지점",
                    value: `${this.alarm.eventObjIdx ? this.alarm.eventObjIdx : "-"} / ${
                        this.event.ptAddr ? this.event.ptAddr : "-"
                    }`,
                },
                { label: "메시지", value: this.alarm.message ? this.alarm.message : "-" },
                { label: "최초 발생", value: this.alarm.regDate ? this.alarm.regDate : "-" },
                { label: "최근 발생", value: this.alarm.modDate ? this.alarm.modDate : "-" },
            ];
        },
        eventOutlierDetailTable() {
            if (!this.event) return [];
            return [
                { label: "이벤트 ID", value: this.event.eventIdx ?? "-" },
                { label: "현재값", value: this.event.measuredVal ?? "-" },
                {
                    label: "정상 범위",
                    value: `${
                        this.event.lowerLimit == 0 || this.event.lowerLimit ? this.event.lowerLimit.toFixed(3) : "-"
                    } ~ ${this.event.upperLimit ? this.event.upperLimit.toFixed(3) : "-"}`,
                },
                { label: "발생 시점", value: this.event.regDt ? this.formatEventDt(this.event.regDt) : "-" },
                { label: "유형", value: this.event.alarmType ? this.convertAlarmType(this.event.alarmType) : "-" },
                { label: "심각도", value: this.event.severity ? this.convertAlarmSeverity(this.event.severity) : "-" },
                { label: "메시지", value: this.event.message ? this.event.message : "-" },
            ];
        },
        eventMissingDetailTable() {
            if (!this.missingEventOverview) return [];
            return [
                { label: "이벤트 ID", value: this.missingEventOverview.eventIdx ?? "-" },
                { label: "결측 총량", value: this.missingEventOverview.missingAmt ?? "-" },
                {
                    label: "결측 횟수",
                    value: this.missingEventOverview.missingCnt ?? "-",
                },
                {
                    label: "결측 구간",
                    value: `${this.formatEventDt(this.missingEventOverview.missingStartDt)} ~ ${this.formatEventDt(this.missingEventOverview.missingEndDt)}`,
                },

                {
                    label: "심각도",
                    value: this.missingEventOverview.severity
                        ? this.convertAlarmSeverity(this.missingEventOverview.severity)
                        : "-",
                },
                {
                    label: "상태",
                    value: this.missingEventOverview.status
                        ? this.getMissingStatus(this.missingEventOverview.status)
                        : "-",
                },
                {
                    label: "메시지",
                    value: `${this.missingEventOverview.message ? this.missingEventOverview.message : "-"}`,
                },
            ];
        },

        alarmLogIdx() {
            return this.eventInfo && this.eventInfo.alarmLogIdx ? this.eventInfo.alarmLogIdx : null;
        },
        boxPlotData() {
            return this.totalLog ? this.totalLog.map((item) => item.ptVal) : [];
        },
        eventTableData() {
            if (this.isMissingEvent()) {
                return this.eventMissingDetailTable;
            } else {
                return this.eventOutlierDetailTable;
            }
        },
    },
    created() {},
    mounted() {
        console.log("this.events", this.events);
    },
    methods: {
        ...mapActions({ updateAlarmLogIdx: "UPDATE_ALARMLOGIDX" }),
        getMissingStatus(status) {
            const found = this.commonCodes.missingStatus.find((item) => item.value === status);
            return found ? found.text : status;
        },
        isMissingEvent() {
            return this.eventInfo.alarmType == "MissingData";
        },

        async getMissingEventOverview(eventIdx) {
            const res = await backEndApi.pointInfo.getMissingEventOverview(eventIdx);
            this.missingEventOverview = res.data.data;
            return res;
        },
        formatEventDt(regDt) {
            if (!regDt) return "-";
            return moment(regDt.toString(), "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
        },
        handleTotalLogModal(flag) {
            this.$emit("handle-total-log-modal", flag);
            this.updateAlarmLogIdx(this.alarmLogIdx);
        },
        convertAlarmStatus(status) {
            const found = this.commonCodes.alarmStatus.find((i) => i.value === status);
            return found ? found.text : status;
        },
        convertAlarmType(type) {
            const found = this.commonCodes.alarmType.find((i) => i.value === type);
            return found ? found.text : type;
        },
        convertAlarmSeverity(severity) {
            const found = this.commonCodes.alarmSeverity.find((i) => i.value === severity);
            return found ? found.text : severity;
        },
    },
};
</script>
<style scoped>
.alarmId {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.boxPlot-chart-container {
    height: 250px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
